import {TALENT_POOL_USER_VALIDATION_ERRORS} from "../../../../hmodules/talent-pool/constants/talent-pool.constants.js";
import {SPEEDY_SOURCES} from "../../constants/speedy-screen.constants.js";

(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("candidateTagsManager", {
            controller: candidateTagsManager,
            bindings: {
                brandId: '<',
                jobBrandId: '<',
                candidateId: '<',
                candidateName: '<',
                applicationId: '<',
                tagsExpandState: '<',
                onExpandTagSection: '&',
                type: '<',
                markAsSilverMedalist: '=',
                isSilverToggleVisible: '<',
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/candidate-tags-manager/candidate-tags-manager.component.html'
        });

    candidateTagsManager.$inject = ['tagsDataService', 'tagsEventsDataService', '$scope', 'talentPoolDataService'];

    function candidateTagsManager(tagsDataService, tagsEventsDataService, $scope, talentPoolDataService) {
        var self = this;
        self.candidateTags = [];
        self.candidateTagsViewData = {};
        self.userValidationErrors = TALENT_POOL_USER_VALIDATION_ERRORS;

        var onBeforeAssignHandler = function (brandId, candidatesIds, tags) {
            var candidateTagsIds = _.pluck(self.candidateTags, "id");

            for (var i in tags) {
                candidateTagsIds.indexOf(tags[i].id) === -1 && self.candidateTags.push(tags[i]);
            }
        };

        var onUnassignFailedHandler = function (brandId, candidatesIds, tags, err) {
            onBeforeAssignHandler(brandId, candidatesIds, tags);
            HNotifications.show({
                title: this.$filter('translate')("Tags Unassign Failed"),
                icon: "fa-times",
                type: "danger",
                timeout: 3000
            });
        };

        var onUnassignFailedEvent = tagsEventsDataService.onUnassignFailed(onUnassignFailedHandler);

        self.onTagToggled = function (data) {
            if (data.status === "SELECTED") {
                var source = (self.applicationId ? "APPLIED" : "SEARCH");
                tagsDataService.assignTagsToCandidates(
                    self.activeBrandId,
                    [self.candidateId],
                    data.tags,
                    source,
                    self.applicationId
                ).then(function () {});
            } else if (data.status === "UNSELECTED") {
                tagsDataService.unassignTagsFromCandidates(self.activeBrandId, [self.candidateId], data.tags).then(function () {});
            }
        };

        self.onTagExpandStateChange = function (tagGroup) {
            self.onExpandTagSection({'tag_group': tagGroup});
        };

        const checkIfCandidateIsBlockedFromRehire = async () => {
            const payload = {
                candidates: [{
                    id: self.candidateId
                }]
            };

            const shortListedCandidates = await TalentPoolAPI2.validateShortListedCandidates(self.activeBrandId, payload);
            const blockedFromRehireErrorObject = shortListedCandidates?.errors?.find((error) => error?.code === self.userValidationErrors.BLOCKED_FROM_REHIRE);

            if (!shortListedCandidates.is_valid && blockedFromRehireErrorObject) {
                return !!blockedFromRehireErrorObject.users?.length;
            }

            return false;
        };

        self.$onInit = async () => {
            try {
                self.isLoading = true;
                self.activeBrandId = [SPEEDY_SOURCES.RH, SPEEDY_SOURCES.RH_INTERVIEW_SCHEDULE, SPEEDY_SOURCES.AMS].includes(self.type) ? self.jobBrandId : self.brandId;
                const [
                    candidateTagsData,
                    isCandidateBlockedFromRehire
                ] = await Promise.all([
                    tagsDataService.getByCandidatesIds(self.activeBrandId, [self.candidateId]),
                    checkIfCandidateIsBlockedFromRehire()
                ]);

                self.candidateTags = candidateTagsData?.[0]?.tags ?? [];
                self.isOptedOutCandidate = candidateTagsData?.[0]?.is_opted_out ?? false;
                self.markAsSilverMedalist = self.candidateTags?.some(tag => tag.mode === tagsDataService.TABS_VALUES.SILVER_MEDALIST);
                self.candidateTagsViewData = tagsDataService.prepareCandidateTagsViewData(self.candidateTags);
                self.isCandidateBlockedFromRehire = isCandidateBlockedFromRehire;
            } catch (e) {
                console.error(e);
            } finally {
                self.isLoading = false;
                $scope.$evalAsync();
            }
        };

        self.$onDestroy = function () {
            tagsEventsDataService.off(onUnassignFailedEvent);
        };
    }
})();
